import { LoanCardTypeEnum } from '@/api/rights/types';
import ProductCommodity from '@/shared/commodity';
import type { ViewConfig } from '../../../ViewRegistry';
import ZhenXiangCard from './index.vue';

export const zhenXiangCardConfig: ViewConfig = {
  viewType: 'zhenxiang-card',
  viewName: '臻享卡购买卡片',
  component: ZhenXiangCard as unknown as ViewConfig['component'],
  priority: 5,
  match: (context) => {
    // 匹配规则：产品ID等于8180
    const productId = context.channel?.productId;
    const { rightSummaryData } = context;
    // 自营模式、轻资产卖量内部闭环、外采 （走的为哈啰权益）
    return productId === ProductCommodity.AUTARKY_B_COMMODITY || (
      [
        LoanCardTypeEnum.CHANNEL_B,
        LoanCardTypeEnum.JOINT_VENTURE,
        LoanCardTypeEnum.OUT_FLOW,
      ].includes(rightSummaryData?.loanCardType || 1)
    );
  },
  props: (context) => ({
    amount: context.amount,
    showSpeed: context.showSpeed,
    checkStatus: context.checkStatus,
    channel: context.channel,
    normalTextList: ['不可享受哈啰定制权益', '不可享受专属的吃喝玩乐权益'],
  }),
  description: '臻享卡购买卡片',
};

export default zhenXiangCardConfig;
